// API Routes Constants
export const API_ROUTES = {
  // Auth routes
  AUTH: {
    SEND_OTP: '/v1/auth/otp/new',
    VERIFY_OTP: '/v1/auth/otp/verify',
    REGISTER: '/v1/auth/register',
    LOGIN: '/v1/auth/login',
    LOGOUT: '/v1/auth/logout',
    REFRESH: '/v1/auth/refresh',
    RESET_PASSWORD: '/v1/auth/password/reset',
  },

  // Account routes
  ACCOUNT: {
    ME: '/v1/account/me',
    FIND: '/v1/account',
    UPDATE: (id: string) => `/v1/account/${id}`,
    DOCTOR: {
      STATS: '/v1/doctor/stats',
      BY_ID: (id: string) => `/v1/account/doctor/${id}`,
      SIGNATURE: '/v1/doctor/signature',
    },
  },

  // Customer routes
  CUSTOMER: {
    LIST: '/v1/customer/list',
  },

  // Product routes
  PRODUCT: {
    SEARCH: '/v1/product/search',
  },

  // Prescription routes
  PRESCRIPTION: {
    CREATE: '/v1/prescription',
    GET_ALL: '/v1/prescription',
    GET_BY_ID: (id: string) => `/v1/prescription/${id}`,
  },

  // Payment routes
  PAYMENT: {
    CARD: {
      GET: '/v2/payment/card',
      // v2 endpoint initializes payment session and returns redirect_url
      POST: '/v2/payment/card',
      DELETE: '/v2/payment/card',
    },
    PAYOUT: {
      GET: '/v2/payment/payout',
    },
    PRESCRIPTIONS: {
      GET: '/v2/payment/prescriptions',
    },
  },

  // News routes
  NEWS: {
    GET: '/v1/news',
  },
} as const;

// API Methods
export const API_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
} as const;

// API Response Types
export interface ApiResponse<T = unknown> {
  success?: boolean;
  message?: string;
  data?: T;
  [key: string]: unknown;
}

export interface PaginatedResponse<T = unknown> {
  data: T[];
  total: number;
  page: number;
  size?: number;
}

// Error types
export interface ApiError {
  status: number;
  message: string;
  code?: number;
  data?: unknown;
}
